<section class="container-fluid survey-container">
  <div class="survey-header">
    <div class="survey-title">Survey Summary</div>

    <a
      class="btn btn-outline-primary btn-sm"
      [href]="rawDataLink"
      target="_blank"
    >
      View Raw Survey Data
    </a>
  </div>
  <div class="summary-top">
    <!-- INFO -->

    <div class="survey-info-box">
      <p>
        The scoring measures the net sentiment of your respondents. It is
        calculated as the difference between the weighted averages of positive
        and negative responses. For a deep dive into the scoring methodology,
        please refer to
        <a
          href="https://drive.google.com/file/d/1_582_cM2hucUsA-0EvV6foHh1pSHxTuf/view"
          target="_blank"
        >
          this document </a
        >.
      </p>
    </div>

    <!-- RESPONDENTS -->

    <div class="respondents-card">
      <div class="respondents-title">Number of Survey Respondents</div>

      <div class="respondent-item">
        Students: {{ counts["countOfStudents"].split('.')[0] }}
      </div>

      <div class="respondent-item">Teachers: {{ counts["countOfTeachers"].split('.')[0] }}</div>

      <div class="respondent-item">Parents: {{ counts["countOfParents"].split('.')[0] }}</div>
    </div>
  </div>
  <div class="row">
    <div
      class="col-lg-6 col-md-12 mb-3"
      *ngFor="let measure of measures; let i = index"
    >
      <div class="measure-card">
        <!-- TITLE -->

        <div class="measure-title">
          MEASURE {{ i + 1 }} : {{ measure.name }} ({{ measure.short }}) OVERALL
          SCORE
        </div>

        <!-- OVERALL SCORE -->

        <div class="overall-row">
          <div class="overall-label">OVERALL SCORE</div>

          <div class="progress overall-progress">
            <div
              class="progress-bar overall-bar"
              [style.width.%]="getWidth(measure.overall.value)"
              [style.background]="measure.overall.color"
            ></div>

            <span class="overall-score-label">
              {{ measure.overall.value || "N/A" }}
            </span>
          </div>

          <div class="status-badge" [style.background]="measure.overall.color">
            {{ measure.overall.status }}
          </div>
        </div>

        <!-- SMALL SCORE ROW -->

        <div class="mini-scores">
          <!-- STUDENT -->

          <div class="mini-score">
            <div class="mini-label">STUDENT SCORE:</div>

            <div class="mini-progress">
              <div
                class="mini-bar"
                [style.width.%]="getWidth(measure.student.value)"
                [style.background]="measure.student.color"
              ></div>

              <span class="mini-score-label">
                {{ measure.student.value || "N/A" }}
              </span>
            </div>
          </div>

          <!-- PARENT -->

          <div class="mini-score">
            <div class="mini-label">PARENT SCORE:</div>

            <div class="mini-progress">
              <div
                class="mini-bar"
                [style.width.%]="getWidth(measure.parent.value)"
                [style.background]="measure.parent.color"
              ></div>

              <span class="mini-score-label">
                {{ measure.parent.value || "N/A" }}
              </span>
            </div>
          </div>

          <!-- TEACHER -->

          <div class="mini-score">
            <div class="mini-label">TEACHER SCORE:</div>

            <div class="mini-progress">
              <div
                class="mini-bar"
                [style.width.%]="getWidth(measure.teacher.value)"
                [style.background]="measure.teacher.color"
              ></div>

              <span class="mini-score-label">
                {{ measure.teacher.value || "N/A" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
